import axiosInstance from "./axiosInstance";

export const forgotEmail = async (correo) => {
  return await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/olvidasteContrasena`,
    { correo }
  );
};

export const recoverPassword = async (codigo, contrasena) => {
  return await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/olvidasteContrasena/reset`,
    { hash: codigo, contrasena }
  );
}

